<template>
  <div class="param-container">
    <!-- 操作按钮 -->
    <div class="compare-buttons ">
      <Button type="primary"  icon="ios-analytics-outline" @click="handleCompare" class="compare-button">
        {{ getTranslation("b060") }}
      </Button>
    </div>
    <Row type="flex" class="device-selection">
      <!-- 源设备选择 -->
      <Col flex="1">
      <Card class="source-device-card" dis-hover>
        <template #title>
          <div class="card-title">
            <Icon type="ios-copy" />
            <span>{{ getTranslation('b061') }}</span>
          </div>
        </template>
        <div class="device-selector">
          <RadioGroup v-model="radMethod" class="compare-radio-group">
            <div class="radio-item">
              <Radio label="controller-controller" size="small"  class="compare-radio">
                <span>{{ getTranslation('b062') }} → {{ getTranslation('b062') }}</span>
              </Radio>
            </div>
            <div class="radio-item">
              <Radio label="controller-library" size="small"  class="compare-radio">
                <span>{{ getTranslation('b062') }} → {{ getTranslation('b002') }}</span>
              </Radio>
            </div>
            <div class="radio-item">
              <Radio label="library-library" size="small"  class="compare-radio">
                <span>{{ getTranslation('b002') }} → {{ getTranslation('b002') }}</span>
              </Radio>
            </div>
          </RadioGroup>
        </div>
      </Card>
      </Col>

      <!-- 目标设备选择 -->
      <Col flex="1">
      <Card class="target-device-card" dis-hover>
        <template #title>
          <div class="card-title">
            <Icon type="ios-list" />
            <span>{{ getTranslation('b006') }}</span>
          </div>
        </template>
        <div class="target-devices" v-show="radMethod == 'controller-controller'">
          <Row class="compare-fields" type="flex">
            <Col flex="1" class="field-label">{{ getTranslation('b113') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :transfer="true" :placeholder="getTranslation('m034')"
              :not-found-text="getTranslation('b038')" size="small" class="compare-select" v-model="m1SelMac1">
              <Option v-for="item in macList" :value="item.id" :key="item.id">{{ item.code }}</Option>
            </Select>
            </Col>
            <Col flex="1" class="field-label">{{ getTranslation('b006') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :transfer="true" :placeholder="getTranslation('m034')" size="small"
              class="compare-select" v-model="m1SelLib1">
              <Option v-for="item in m1MacLibraryList1" :value="item.id" :key="item.id">{{ item.id }}</Option>              
            </Select>
            </Col>
          </Row>

          <Row class="compare-fields" type="flex">
            <Col flex="1" class="field-label">{{ getTranslation('b114') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')"
              size="small" class="compare-select" v-model="m1SelMac2">
              <Option v-for="item in macList" :value="item.id" :key="item.id">{{ item.code }}</Option>
            </Select>
            </Col>
            <Col flex="1" class="field-label">{{ getTranslation('b006') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :transfer="true" :placeholder="getTranslation('m034')" size="small"
              class="compare-select" v-model="m1SelLib2">
              <Option v-for="item in m1MacLibraryList2" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select>
            </Col>
          </Row>
        </div>

        <div class="target-devices" v-show="radMethod == 'controller-library'">
          <Row class="compare-fields" type="flex">
            <Col flex="1" class="field-label">{{ getTranslation('b062') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :transfer="true" :placeholder="getTranslation('m034')"
              :not-found-text="getTranslation('b038')" size="small" class="compare-select" v-model="m2SelMac1">
              <Option v-for="item in macList" :value="item.id" :key="item.id">{{ item.code }}</Option>
            </Select>
            </Col>
            <Col flex="1" class="field-label">{{ getTranslation('b006') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :transfer="true" :placeholder="getTranslation('m034')" size="small"
              class="compare-select" v-model="m2SelLib1">
              <Option v-for="item in m2MacLibraryList1" :value="item.id" :key="item.id">{{ item.id }}</Option>
            </Select>
            </Col>
          </Row>
          <Row class="compare-fields" type="flex">
            <Col flex="1" class="field-label">{{ getTranslation('b002') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')"
              size="small" class="compare-select" v-model="m2SelLib2">
              <Option v-for="item in libraryList" :value="item.program_id" :key="item.program_id">{{ item.program_id }}</Option>
            </Select>
            </Col>
            <Col flex="3" class="field-label">
            </Col>
          </Row>
        </div>
        <div class="target-devices" v-show="radMethod == 'library-library'">
          <Row class="compare-fields" type="flex">
            <Col flex="1" class="field-label">{{ getTranslation('b115') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')"
              size="small" class="compare-select" v-model="m3SelLib1">
              <Option v-for="item in libraryList" :value="item.program_id" :key="item.program_id">{{ item.program_id }}</Option>
            </Select>
            </Col>
            <Col flex="3" class="field-label">
            </Col>
          </Row>
          <Row class="compare-fields" type="flex">
            <Col flex="1" class="field-label">{{ getTranslation('b116') }}</Col>
            <Col flex="2" class="compare-selector">
            <Select :filterable="true" :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')"
              size="small" class="compare-select" v-model="m3SelLib2">
              <Option v-for="item in libraryList" :value="item.program_id" :key="item.program_id">{{ item.program_id }}</Option>
            </Select>
            </Col>
            <Col flex="3" class="field-label">
            </Col>
          </Row>
        </div>
      </Card>
      </Col>
    </Row>
    <div v-if="resCompare && resCompare.length > 0" class="compare-result-container">
      <div class="compare-table">
        <div class="table-header">
          <div class="header-cell">{{ getTranslation("b065") }}</div>
          <div class="header-cell">{{ libraryOne }}</div>
          <div class="header-cell">{{ libraryTow }}</div>
        </div>
        <div v-for="(item, index) in resCompare" :key="index" :class="['table-row', { 'abnormal-row': !item.Same }]">
          <div class="table-cell">{{ item.Alias }}</div>
          <div class="table-cell">{{ item.Original }}</div>
          <div class="table-cell">{{ item.Present }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { API_URL } from '@/constants/const.js'
import { kindMapLibrary, postJsError } from '@/util/util';
import axios from 'axios';
import { Button, Select, Option, Row, Col, Card, Icon, RadioGroup, Radio } from 'view-design';
import { mapGetters } from 'vuex';
export default {
  name: 'ParamCompare',
  components: {
    Button, Select, Option, Row, Col, Card, Icon, RadioGroup, Radio
  },
  props: {

  },
  data() {
    return {
      radMethod: 'controller-controller',
      macList: [],
      libraryList: [],
      m1SelMac1: '',
      m1SelLib1: '',
      m1SelMac2: '',
      m1SelLib2: '',
      m2SelMac1: '',
      m2SelLib1: '',
      m2SelLib2: '',
      m3SelLib1: '',
      m3SelLib2: '',
      resCompare: [],
      libraryOne: '',
      libraryTow: '',
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    m1MacLibraryList1() {
      let rs = [];
      let kind = -1;
      this.macList && this.macList.forEach((item) => {
        if (item.id == this.m1SelMac1) {
          kind = item.kind
        }
      })
      if (kind > -1) {
        let size = kindMapLibrary(kind);
        for (var i = 0; i < size; i++) {
          rs.push({ "id": i, "ProgramId": i })
        }
        this.m1SelLib1 = 0
      }
      return rs;
    },
    m1MacLibraryList2() {
      let rs = [];
      let kind = -1;
      this.macList && this.macList.forEach((item) => {
        if (item.id == this.m1SelMac2) {
          kind = item.kind
        }
      })
      if (kind > -1) {
        let size = kindMapLibrary(kind);
        for (var i = 0; i < size; i++) {
          rs.push({ "id": i, "ProgramId": i })
        }
        this.m1SelLib2 = 0
      }
      return rs;
    },
    m2MacLibraryList1() {
      let rs = [];
      let kind = -1;
      this.macList && this.macList.forEach((item) => {
        if (item.id == this.m2SelMac1) {
          kind = item.kind
        }
      })
      if (kind > -1) {
        let size = kindMapLibrary(kind);
        for (var i = 0; i < size; i++) {
          rs.push({ "id": i, "ProgramId": i })
        }
        this.m2SelLib1 = 0
      }
      return rs;
    },

  },
  watch: {

  },
  created() {
    this.init();
  },
  mounted() {


  },
  methods: {
    init() {
      this.getData();
    },
    getData() {
      let url = API_URL["libraryInit"];
      let params = {
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.macList = res.data.data.macList;
            this.libraryList = res.data.data.library;
            if (this.macList && this.macList.length > 0) {
              this.m1SelMac1 = this.macList[0].id
              this.m1SelMac2 = this.macList[0].id
              this.m2SelMac1 = this.macList[0].id
            }
            if (this.libraryList && this.libraryList.length > 0) {
              this.m2SelLib2 = this.libraryList[0].program_id
              this.m3SelLib1 = this.libraryList[0].program_id
              this.m3SelLib2 = this.libraryList[0].program_id
            }
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('m041'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    handleCompare() {
      let url = API_URL["libraryCompare"];
      var program1 = null;
      var program2 = null;
      var mac1 = null;
      var mac2 = null;
      switch (this.radMethod) {
        case 'controller-controller':
          mac1 = this.m1SelMac1
          mac2 = this.m1SelMac2
          program1 = this.m1SelLib1
          program2 = this.m1SelLib2
          this.libraryOne = this.getTranslation('b113') + this.getTranslation('b006') + program1;
          this.libraryTow = this.getTranslation('b114') + this.getTranslation('b006') + program2;
          break;
        case 'controller-library':
          mac1 = this.m2SelMac1
          program1 = this.m2SelLib1
          program2 = this.m2SelLib2
          this.libraryOne = this.getTranslation('b062') + this.getTranslation('b006') + program1;
          this.libraryTow = this.getTranslation('b002') + this.getTranslation('b006') + program2;
          break;
        case 'library-library':
          program1 = this.m3SelLib1
          program2 = this.m3SelLib2
          this.libraryOne = this.getTranslation('b002') + this.getTranslation('b006') + program1;
          this.libraryTow = this.getTranslation('b002') + this.getTranslation('b006') + program2;

          break;
        default:
          break;
      }
      let params = {
        kind: this.radMethod,
        mac1: mac1,
        mac2: mac2,
        program1: program1,
        program2: program2,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.resCompare = res.data.data;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('m041'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })


    }
  }
}
</script>

<style scoped>
.param-container {
  padding: 20px;
  margin: 0 auto;

}

.device-selection {
  margin-bottom: 24px;
  width: 100%;
}

.source-device-card,
.target-device-card {
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-title i {
  font-size: 18px;
  color: #2d8cf0;
}

.device-selector {
  padding: 16px 0;
}

.compare-radio-group {
  width: 100%;
}

.radio-item {
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.radio-item:hover {
  background-color: #f8f9fa;
}

.compare-radio :deep(.ivu-radio-wrapper) {
  font-size: 14px;
}

.compare-radio :deep(.ivu-radio-checked .ivu-radio-inner) {
  border-color: #2d8cf0;
  background-color: #2d8cf0;
}

.target-devices {
  padding: 16px 0;
}

.compare-fields {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}

.field-label {
  color: #515a6e;
  font-size: 14px;
  display: flex;
  justify-content: right;
  align-items: center;
  padding-right: 5px;

}

.compare-select {
  width: 80%;
}

.compare-select :deep(.ivu-select-selection) {
  border-radius: 6px;
  border: 1px solid #dcdee2;
  transition: all 0.2s ease;
}

.compare-select :deep(.ivu-select-selection:hover) {
  border-color: #57a3f3;
}

.compare-select :deep(.ivu-select-selection:focus) {
  border-color: #2d8cf0;
  box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
}

.select-all-section {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8eaec;
}


.devices-list {
  margin-bottom: 16px;
}

.device-checkbox-col {
  margin-bottom: 12px;
}

.device-checkbox {
  width: 100%;
}

.device-checkbox :deep(.ivu-checkbox) {
  margin-right: 8px;
}

.disabled-text {
  color: #c5c8ce;
  cursor: not-allowed;
}

.compare-buttons {
  text-align: center;
  margin: 24px 0;
}

.compare-button {
  min-width: 120px;
  height: 30px;
  font-size: 14px;
}

.compare-button :deep(.ivu-icon) {
  margin-right: 8px;
}

.compare-result-container {
  margin-top: 20px;
  border: 1px solid #e8eaec;
  border-radius: 6px;
  overflow: hidden;
}

.compare-table {
  width: 100%;
}

.table-header {
  display: flex;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e8eaec;

}

.header-cell {
  flex: 1;
  padding: 8px 12px;
  font-size: 12px;
  color: #515a6e;
  text-align: center;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background-color: #f5f7fa;
}

.table-cell {
  flex: 1;
  padding: 8px 12px;
  font-size: 12px;
  color: #606266;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}


.abnormal-row {
  background-color: #fff2f0 !important;
  border-left: 3px solid #ff4d4f;
}

.abnormal-row .table-cell {
  color: #ff4d4f;
}

.abnormal-row:hover {
  background-color: #ffe6e6 !important;
}
</style>